import assign from "lodash/assign";
import { ChatbotState, ChatbotActions, ChatbotActionTypes } from "~/types/chatbot";
import { ReduxState } from "~/types/redux";
const initialState: ChatbotState = {
  status: "DISABLED",
  triggerType: null,
  proactiveModalViewed: {},
  gigaEventTriggered: {},
  vasCounter: 0,
  productCounter: 0,
  vasTriggeredPages: {},
  productTriggeredPages: {}
};
const chatbot = (state: ReduxState, action: ChatbotActions): ReduxState => {
  switch (action.type) {
    case ChatbotActionTypes.SET_CHATBOT_STATUS:
      return assign({}, state, {
        chatbot: assign({}, state.chatbot || initialState, {
          status: action.status
        })
      });
    case ChatbotActionTypes.SET_CHATBOT_TRIGGER_TYPE:
      return assign({}, state, {
        chatbot: assign({}, state.chatbot || initialState, {
          triggerType: action.triggerType
        })
      });
    case ChatbotActionTypes.SET_PROACTIVE_MODAL_VIEWED_PAGE:
      return assign({}, state, {
        chatbot: assign({}, state.chatbot || initialState, {
          proactiveModalViewed: {
            ...state.chatbot.proactiveModalViewed,
            [action.page]: action.viewed
          }
        })
      });
    case ChatbotActionTypes.SET_GIGA_EVENT_TRIGGERED_PAGE:
      return assign({}, state, {
        chatbot: assign({}, state.chatbot || initialState, {
          gigaEventTriggered: {
            ...state.chatbot.gigaEventTriggered,
            [action.page]: action.viewed
          }
        })
      });
    case ChatbotActionTypes.SET_PROACTIVE_MODAL_CONTENT:
      return assign({}, state, {
        chatbot: assign({}, state.chatbot || initialState, {
          proactiveModalContent: action.proactiveModalContent
        })
      });
    case ChatbotActionTypes.INCREMENT_VAS_COUNTER:
      return assign({}, state, {
        chatbot: assign({}, state.chatbot || initialState, {
          vasCounter: state.chatbot.vasCounter + 1
        })
      });
    case ChatbotActionTypes.INCREMENT_PRODUCT_COUNTER:
      return assign({}, state, {
        chatbot: assign({}, state.chatbot || initialState, {
          productCounter: state.chatbot.productCounter + 1
        })
      });
    case ChatbotActionTypes.MARK_VAS_TRIGGERED_PAGE:
      return assign({}, state, {
        chatbot: assign({}, state.chatbot || initialState, {
          vasTriggeredPages: {
            ...state.chatbot.vasTriggeredPages,
            [action.page]: true
          }
        })
      });
    case ChatbotActionTypes.MARK_PRODUCT_TRIGGERED_PAGE:
      return assign({}, state, {
        chatbot: assign({}, state.chatbot || initialState, {
          productTriggeredPages: {
            ...state.chatbot.productTriggeredPages,
            [action.page]: true
          }
        })
      });
    default:
      return state;
  }
};
export default chatbot;